/** @jsx jsx */
import { jsx } from "theme-ui";
import React from "react";
import {
  InfoWindow as ReactGoogleMapsInfoWindow,
  InfoWindowProps as ReactGoogleMapsInfoWindowProps,
} from "@react-google-maps/api";

export type GoogleMapInfoWindowProps = ReactGoogleMapsInfoWindowProps;

const GoogleMapInfoWindow: React.FC<GoogleMapInfoWindowProps> = ({
  ...props
}) => <ReactGoogleMapsInfoWindow {...props} />;

GoogleMapInfoWindow.defaultProps = {};

export { GoogleMapInfoWindow };
